import { formDictionary, UpdateCustomerForm } from "@unlikelystudio/react-ecommerce-hooks"

import type { PropsWithClassName } from "~/@types/generics"
import { ALERT_CODES } from "~/lib/constants"
import useMutationErrors from "~/hooks/account/useMutationErrors"
import { useAlerts } from "~/hooks/useAlerts"
import { FORM_NAMES, FormTemplate } from "~/components/forms/FormTemplate"
import { useTranslate } from "~/providers/I18nProvider/hooks/useTranslate"
import { objectKeys } from "~/utils/object-keys"

type UpdatePasswordTemplateProps = PropsWithClassName<{}>

function UpdatePasswordTemplate({ className }: UpdatePasswordTemplateProps) {
  const onError = useMutationErrors()
  const triggerAlert = useAlerts()

  const t = useTranslate()

  const onSuccess = () => {
    triggerAlert(ALERT_CODES.ENTITY_SAVED)
  }

  const overridenDictionary = objectKeys(formDictionary).reduce((acc, curr) => {
    return {
      ...acc,
      [curr]: { ...formDictionary[curr], submitUpdateCustomer: t("account_reset_password") },
    }
  }, {} as typeof formDictionary)

  return (
    <FormTemplate
      className={className}
      dictionary={overridenDictionary}
      withRequiredText
      formName={FORM_NAMES.RESET_PASSWORD}
    >
      <UpdateCustomerForm
        hideFields={["birthdate", "firstName", "phone", "lastName", "gender", "email", "acceptsMarketing"]}
        mutationOptions={{
          onSuccess,
          onError,
        }}
      />
    </FormTemplate>
  )
}

export { UpdatePasswordTemplate }
